import React from 'react';
import styled from 'styled-components';

interface KeypadSelectorProps {
  value: string | null;
  onChange: (value: string) => void;
  disabledKeys?: string[];
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 48px);
  justify-content: center;
  gap: 10px;
`;
const KeyButton = styled.button<{ $disabled: boolean; $selected: boolean }>`
  width: 48px; height: 48px; padding: 0; border-radius: 50%;
  border: 1px solid ${({ theme, $selected }) => $selected ? theme.color.point_y_100 : theme.color.primary_300};
  background: ${({ theme, $disabled, $selected }) => $disabled ? theme.color.primary_50 : $selected ? `${theme.color.point_y_100}18` : theme.color.primary_100};
  color: ${({ theme, $disabled, $selected }) => $disabled ? theme.color.text_color_400 : $selected ? theme.color.point_y_100 : theme.color.text_color_100};
  box-shadow: ${({ theme, $disabled, $selected }) => $disabled ? 'none' : $selected ? `0 2px 6px ${theme.color.point_y_100}26` : '0 1px 3px rgba(16, 24, 40, 0.08)'};
  font-size: 20px; font-weight: 700; cursor: ${({ $disabled }) => $disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ $disabled }) => $disabled ? 0.5 : 1};
  transition: background-color 140ms, border-color 140ms, color 140ms;
  &:hover { ${({ $disabled, theme }) => !$disabled && `border-color: ${theme.color.point_y_100}; background: ${theme.color.point_y_100}0D;`} }
  &:active { ${({ $disabled, theme }) => !$disabled && `background: ${theme.color.point_y_100}1A;`} }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 2px; }
`;

const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

const KeypadSelector = ({ value, onChange, disabledKeys = [] }: KeypadSelectorProps) => <Grid>
  {keys.map(key => {
    const disabled = disabledKeys.includes(key);
    return <KeyButton key={key} type="button" onClick={() => !disabled && onChange(key)} disabled={disabled} $disabled={disabled} $selected={value === key} aria-pressed={value === key}>{key}</KeyButton>;
  })}
</Grid>;

export default KeypadSelector;
